import { ChatRoomList } from 'ui/components/agent/patterns/ChatRoom/ChatRoomList';

/**
 * 仲介業者チャットページ
 */
export const AgentChatRoom: React.FC = () => {
    return <ChatRoomList />;
};
